module.exports = {"pathContext":{"name":"RecurrenceEditScope","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Update this and all future appointments in the series.","isDeprecated":false,"name":"ALL_OCCURRENCES"},{"deprecationReason":null,"description":"Update this single appointment occurrence only.","isDeprecated":false,"name":"THIS_OCCURRENCE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-recurrence-edit-scope.json
// module id = 1294
// module chunks = 206061371186326